
import { Component, ViewChild } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";

import { DxFileUploaderComponent } from "devextreme-angular";
import { Catalog } from "../../../../Model/Catalog/Catalog";
import { ModelService } from "../../../../Services/model.service";

@Component({
  selector: "importSupplierPidMappings",
  templateUrl: "supplierPidMappings.component.html"
})
export class ImportSupplierPidMappingsComponent {
  @ViewChild(DxFileUploaderComponent, { static: true })
  dxfileuploader: DxFileUploaderComponent;

  value: any[] = [];
  model: Catalog[];
  uploadHeaders: any;

  constructor(private modelService: ModelService, private oAuthService: OAuthService) {
    this.onBeforeSendUpload = this.onBeforeSendUpload.bind(this);

    this.uploadHeaders = {
      CustomerId: this.modelService.loginService.currentUser.customerId
    }
  }

  onBeforeSendUpload(e: { request: XMLHttpRequest }) {
    e.request.withCredentials = true;
    e.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
  }

  onUploaded() {
    this.dxfileuploader.instance.reset();
  }
}
